var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"landing"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-container',{staticClass:"px-0"},[_c('div',{staticClass:"text-right"},[_c('I18n')],1),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('color.dio'))}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }